import {FC} from 'react'
import {BaseButtonType, Button} from 'shared/ui/buttons'


export const RegisterButton: FC<BaseButtonType> = (props) =>
  <Button fullwidth={props.fullwidth} className={props.className} as='link' to='/register' styleType='primary' children={props.children} />
